export default "__VITE_ASSET__D8qO02PG__"